<template>
    <div class="modal fade" id="actionRemarks" tabindex="-1" role="dialog" aria-labelledby="actionRemarksTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="actionRemarksTitle">Add Remarks</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearRemarks">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="form-group mt-1">
                        <textarea class="form-control" id="endorsedRemarks" v-model="newRemarks.remarks" style="height: 100px; resize: none;" rows="3"  @keydown="limiteTextRemarks('endorsedRemarks','countdown2',200)"></textarea>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn tnkc-success" @click="setApproved">
                        <font-awesome-icon icon="save"/>
                        Save changes
                    </button>
                    <button type="button" class="btn tnkc-secondary" data-dismiss="modal">
                        <font-awesome-icon icon="times"/>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {appMixins} from '../../../mixins/app.mixins';
  import {mapGetters,mapActions} from 'vuex';

  export default {
    name: 'approveEndorseModal',
    mixins:[appMixins],
    props:{
      approved : {type: Function},
      cancel : {type: Function},
      extend : {type: Function},
      actType : Number,
    },

    methods:{
      //actions.
      ...mapActions(['setNullNewRemark']),

      setApproved(){
        switch (this.actType) {
          case 1:
            this.approved();
            break;

          case 2:
            this.cancel();
            break;

          case 3:
            this.extend();
            break;
        }
      },

      clearRemarks(){
       this.setNullNewRemark();
      }
    },

    computed:{
      ...mapGetters(['newRemarks'])
    },

    created() {

    },

    mounted() {

    },
  };
</script>

<style scoped>

</style>